import EnumHelper, { ToListItems } from '@core/helpers/enum-helper';
import { CreditBureaurs as CreditBureaus, DealType } from '@core/classes/SharedEnums';

export default class CreditBureausEnumsHelper extends EnumHelper<CreditBureaus> {
	static toList: ToListItems<CreditBureaus>[] = [
		{
			display: 'Equifax',
			value: CreditBureaus.Equifax,
		},
		{
			display: 'Experian',
			value: CreditBureaus.Experian,
		},
		{
			display: 'TransUnion',
			value: CreditBureaus.TransUnion,
		},
	];

	constructor() {
		super(CreditBureausEnumsHelper.toList);
	}
}
